import Form from '../_.extend';
import { onSuccess, onError } from './utilities/formHooks';

// make fields
export const makeFields: Function = (t: Function) => {
  const fields = [
    'chooseAccount',
    'chooseAccount.tradingAccount',
    'assetDetails',
    'assetDetails[].manufacturer',
    'assetDetails[].model',
    'assetDetails[].quantity',
    'assetDetails[].description',
    'assetDetails[].additionalInformation',
    'requiredDates',
    'requiredDates.startDate',
    'requiredDates.endDate',
    'assignProjects',
    'assignProjects.list',
    'assignCostCentre',
    'assignCostCentre.list',
    'additionalInformation',
    'additionalInformation.details',
    'customerDetails',
    'customerDetails.name',
    'customerDetails.phoneNo',
    'customerDetails.company',
    'customerDetails.site',
    'customerDetails.deliveryIsEqual',
    'deliveryDetails',
    'deliveryDetails.name',
    'deliveryDetails.phoneNo',
    'deliveryDetails.company',
    'deliveryDetails.site',
    'deliveryDetails.specialInstructions',
  ];
  const labels = {
    chooseAccount: t('general:actions.choose_trading_account'),
    'chooseAccount.tradingAccount': t('general:actions.choose_trading_account'),
    assetDetails: t('general:assets.labels.details'),
    'assetDetails[].manufacturer': t('general:manufacturer'),
    'assetDetails[].model': t('general:model'),
    'assetDetails[].quantity': t('general:labels.quantity'),
    'assetDetails[].description': t('general:description'),
    'assetDetails[].additionalInformation': t('general:labels.additional_info'),
    requiredDates: t('general:labels.required_dates'),
    'requiredDates.startDate': t('general:labels.start_date'),
    'requiredDates.endDate': t('general:labels.end_date'),
    assignProjects: t('general:actions.assign_project'),
    'assignProjects.list': t('general:actions.choose_projects'),
    assignCostCentre: t('general:actions.assign_cost_center'),
    'assignCostCentre.list': t('general:actions.choose_cost_center'),
    additionalInformation: t('general:labels.additional_info'),
    'additionalInformation.details': t('general:labels.additional_info'),
    customerDetails: t('general:labels.customer_details'),
    'customerDetails.name': t('general:labels.contact_name'),
    'customerDetails.phoneNo': t('general:labels.contact_phone_number'),
    'customerDetails.company': t('general:company'),
    'customerDetails.site': t('general:locations.labels.site'),
    'customerDetails.deliveryIsEqual': t('general:actions.delivery_is_equal'),
    deliveryDetails: t('general:labels.delivery_details'),
    'deliveryDetails.name': t('general:labels.contact_name'),
    'deliveryDetails.phoneNo': t('general:labels.contact_phone_number'),
    'deliveryDetails.company': t('general:company'),
    'deliveryDetails.site': t('general:locations.labels.site'),
    'deliveryDetails.specialInstructions': t('general:labels.special_instructions'),
  };
  const rules = {
    'chooseAccount.tradingAccount': 'required',
    assetDetails: 'required|array|min:1',
    'assetDetails[].manufacturer': 'required|string',
    'assetDetails[].model': 'required|string',
    'assetDetails[].quantity': 'required|integer',
    'assetDetails[].description': 'string',
    'requiredDates.startDate': 'required|date',
    'requiredDates.endDate': 'required|date',
    'assignProjects.list': 'string',
    'assignCostCentre.list': 'string',
    additionalInformation: 'string',
    'customerDetails.phoneNo': 'telephone',
    'customerDetails.company': 'required|string',
    'customerDetails.site': 'required|string',
    'customerDetails.deliveryIsEqual': 'boolean',
    'deliveryDetails.phoneNo': 'telephone',
    'deliveryDetails.company': 'required|string',
    'deliveryDetails.site': 'required|string',
  };
  const extra = {
    'chooseAccount.tradingAccount': {
      // used to fetch all the modelChild data (don't know why this HAS to be here)
      // it's deep with the ElectroSelectExtra component
      selectID: '',
    },
    'assetDetails[].manufacturer': {
      childExtraFilters: [
        {
          type: 'formField',
          formName: 'assetDetails',
          formField: 'manufacturer',
          isExtra: true,
          isNested: true,
          value: 'selectID',
        },
        {
          type: 'formFieldParam',
          formName: 'chooseAccount',
          formField: 'tradingAccount',
          isExtra: true,
          value: 'selectID',
          paramName: '?account_id',
        },
      ],
    },
    'assetDetails[].model': {
      setSelectedFields: [
        {
          field: 'description',
          value: 'product_group_description',
        },
        {
          field: 'quantity',
          value: 1,
        },
      ],
    },
    'assetDetails[].quantity': {
      options: [
        { id: 1, name: 1 },
        { id: 2, name: 2 },
        { id: 3, name: 3 },
        { id: 4, name: 4 },
        { id: 5, name: 5 },
      ],
    },
    assignProjects: {
      actionButton: true,
    },
    'assignProjects.list': {
      actionButton: true,
    },
    assignCostCentre: {
      actionButton: true,
    },
    'assignCostCentre.list': {
      actionButton: true,
    },
    'customerDetails.company': {
      selectID: '',
      actionButton: true,
      childExtraFilters: [
        {
          type: 'formField',
          formName: 'customerDetails',
          formField: 'company',
          isExtra: true,
          value: 'selectID',
        },
      ],
    },
    'customerDetails.site': {
      selectID: '',
      actionButton: true,
      childExtraFilters: [
        {
          type: 'formField',
          formName: 'customerDetails',
          formField: 'company',
          isExtra: true,
          value: 'selectID',
        },
        {
          type: 'string',
          value: '?parent_id=',
        },
      ],
    },
    'deliveryDetails.company': {
      selectID: '',
      parentId: '',
      actionButton: true,
      childExtraFilters: [
        {
          type: 'formField',
          formName: 'deliveryDetails',
          formField: 'company',
          isExtra: true,
          value: 'selectID',
        },
      ],
    },
    'deliveryDetails.site': {
      selectID: '',
      actionButton: true,
      childExtraFilters: [
        {
          type: 'formField',
          formName: 'deliveryDetails',
          formField: 'company',
          isExtra: true,
          value: 'selectID',
        },
        {
          type: 'string',
          value: '?parent_id=',
        },
      ],
    },
  };

  return { labels, fields, rules, extra };
};

// Form instance
class AssetRequestForm extends Form {}

// make hooks
export const createAssetRequestForm: Function = (
  fieldOptions: Array<*>,
  localState: Object,
  t: Function
) => {
  const { labels, fields, rules, extra } = fieldOptions;
  const hooks: Object = {
    onSuccess: onSuccess(fields, localState, t),
    onError: onError(fields, localState, t),
  };

  return new AssetRequestForm({ labels, fields, rules, extra }, { hooks });
};
